export default __webpack_public_path__ + "static/media/group_collab_tag.15c2a534.png";